import { accountGetInfo, getMembershipInformation } from '@/service/api/basic'
import { getAllUserinfo } from '@/service/api/domain/template'
/** 常用接口方法  */
export const useApiStore = defineStore('api-store', {
  state: () => {
    return {
    }
  },
  getters: {
  },
  actions: {
    /** 获取会员信息 */
    async getMembershipInformationFn() {
      try {
        const { code, data } = await getMembershipInformation()
        if (code !== 1000)
          return
        return data
      }
      catch (e) {
        console.warn('获取会员信息失败:', e)
      }
    },
    /** 获取会员模板信息 */
    async getAllUserinfoFn() {
      try {
        const { code, data } = await getAllUserinfo()
        if (code !== 1000)
          return
        return data
      }
      catch (e) {
        console.warn('获取会员模板信息失败:', e)
      }
    },
    /** 查询个人账户余额信息 */
    async accountGetInfo() {
      try {
        const { code, data } = await accountGetInfo()
        if (code !== 1000)
          return
        return data
      }
      catch (e) {
        console.warn('获取个人账户余额信息失败:', e)
      }
    },
  },
})
